module.exports = __webpack_public_path__ + "static/media/alert_rieltor_gift.a6de9352.png";